var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('BaseTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"title":"Anfo Vergütung","componentName":'OrderCompensationOverview',"deleteMutation":'deleteOrderCompensation',"loading":_vm.loading},on:{"refresh":_vm.updateList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }